import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <div className="navbar">
      <h1 className="navbar-brand" href="/">
        Texify Elite
      </h1>
      <div>
        <a className="navbar-link" target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/avijitd22/">
          LinkedIn
        </a>
        <a className="navbar-link" target="_blank" rel="noreferrer" href="https://avijitd22.vercel.app/">
          Portfolio
        </a>
      </div>
    </div>
  );
};

export default Header;
